module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "music",
      "transition": "fade"
    }
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "music-box"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "left fleft"
  }, [_c('img', {
    attrs: {
      "src": _vm.current.pic,
      "width": "70px",
      "height": "69px",
      "onerror": "this.src='data:image/jpeg;base64,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'"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right fleft"
  }, [_c('div', {
    staticClass: "line song-control",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "pp glyphicon",
    class: {
      'glyphicon-play': !_vm.player.play, 'glyphicon-pause': _vm.player.play
    },
    attrs: {
      "title": "开始/暂停"
    },
    on: {
      "click": _vm.pause
    }
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.next
    }
  }, [_c('span', {
    staticClass: "forward glyphicon glyphicon-forward",
    attrs: {
      "title": "下一首"
    }
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.toggleLrc
    }
  }, [_c('span', {
    staticClass: "lrc-list glyphicon",
    class: {
      'glyphicon-text-width': !_vm.player.lrc, 'glyphicon-list': _vm.player.lrc
    },
    attrs: {
      "title": "切换歌词/列表"
    }
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.togglePlayerMod
    }
  }, [_c('span', {
    staticClass: "play-type glyphicon",
    class: {
      'glyphicon-music': _vm.player.mod === 'seq', 'glyphicon-repeat': _vm.player.mod == 'cycle', 'glyphicon-random': _vm.player.mod === 'rand'
    },
    attrs: {
      "title": "播放方式"
    }
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.share
    }
  }, [_c('span', {
    staticClass: "share-qzone glyphicon glyphicon-share",
    attrs: {
      "title": "分享到QQ空间"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "middle"
  }, [_c('div', {
    staticClass: "line song-info",
    staticStyle: {
      "height": "24px",
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "song-name fleft"
  }, [_c('span', [_vm._v(_vm._s(_vm.current.song))])]), _vm._v(" "), _c('div', {
    staticClass: "song-time fleft text-right"
  }, [_c('span', {
    staticClass: "current-time"
  }, [_vm._v(_vm._s(_vm.current.current_time))]), _vm._v("/"), _c('span', {
    staticClass: "total-time"
  }, [_vm._v(_vm._s(_vm.current.total_time))])])]), _vm._v(" "), _c('div', {
    staticClass: "progress",
    staticStyle: {
      "height": "5px",
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "progress-bar",
    style: ('width: ' + _vm.current.percent + '%;'),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "60",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("60% Complete")])])])]), _vm._v(" "), _c('div', {
    staticClass: "song-center"
  }, [_c('div', {
    staticClass: "song-wrap",
    class: {
      'transform-lrc': _vm.player.lrc
    }
  }, [_c('div', {
    staticClass: "song-list"
  }, [_c('ul', _vm._l((_vm.songs), function(r) {
    return _c('li', {
      class: {
        'active': _vm.current.id === r.id
      },
      attrs: {
        "data-index": r.id,
        "data-id": r.netid
      },
      on: {
        "click": function($event) {
          return _vm.selectSong({
            id: r.id,
            netId: r.netid,
            title: r.title
          })
        }
      }
    }, [_vm._v(_vm._s((r.id) + '.' + r.title))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "song-lrc"
  }, [_c('div', {
    staticClass: "lrc-content",
    style: ({
      'margin-top': -_vm.player.lrcline * 27 + 'px'
    })
  }, [(_vm.LRC.words.length < 1) ? _c('p', {
    staticClass: "text-center"
  }, [_vm._v("暂无歌词")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.LRC.words), function(v, k, idx) {
    return _c('p', {
      staticClass: "text-center"
    }, [_c('span', {
      class: {
        'active': idx === _vm.player.lrcline
      }
    }, [_vm._v(_vm._s(v))])])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a05a2bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Music.vue
// module id = 98
// module chunks = 0